var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#square_clip0)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.492 0H3.51A3.51 3.51 0 000 3.51v13.982a3.51 3.51 0 003.51 3.51h13.982a3.51 3.51 0 003.51-3.51V3.51A3.51 3.51 0 0017.492 0zm-.308 16.077a1.107 1.107 0 01-1.108 1.107H4.928a1.107 1.107 0 01-1.108-1.107V4.927A1.107 1.107 0 014.928 3.82h11.148a1.107 1.107 0 011.108 1.108v11.149z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.272 13.365a.637.637 0 01-.635-.639v-4.45c0-.353.284-.64.635-.64h4.457c.352 0 .636.287.636.64v4.45c0 .353-.284.64-.636.64H8.272z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "square_clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v21H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.8c53c50bcb5514547f03e3e045dbe714.svg";
export { ForwardRef as ReactComponent };